export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': '数据统计',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.userSoftwareManagement': '软件授权详情',
  'menu.sales': '销售管理',
  'menu.sales.customers': '客户列表',
  'menu.department': '部门管理',
  'menu.department.department': '部门管理',
  'menu.account-management': '账号管理',
  'menu.account-management.management': '账号管理',
  'menu.account-management.card-list': '授权管理',
  'menu.account-management.role-settings': '角色设置',
  'menu.account-management.device-management': '设备管理',
  'menu.account-management.logs': '操作日志',
  'menu.software-management': '软件管理',
  'menu.software-management.software-list': '软件列表',
  'menu.software-management.launchers': '软件启动器',
  'menu.software-management.software-versions': '版本管理',
  'menu.software-management.safety-certificate': '授权管理',
  'menu.software-management.device_emanager': '设备管理',
  'menu.software-management.activation_codes': '激活码管理',
  'menu.notificationManagement': '通知管理',
  'menu.backdoor': '软件账号维护',
  'menu.backdoor.accounts': '账号信息',
  'menu.backdoor.tasks': '任务进度',
  'menu.backdoor.configs': '参数设置',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};

